import React from 'react';
import { authRoles } from 'app/auth';

export const SettingsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.admin,
	routes: [
		// More specific routes must come before the generic :section? route
		{
			path: '/settings/storage/providers',
			component: React.lazy(() => import('./storage/StorageProvidersPage'))
		},
		{
			path: '/settings/storage/policies',
			component: React.lazy(() => import('./storage/StoragePoliciesPage'))
		},
		{
			path: '/settings/:section?',
			component: React.lazy(() => import('./AdminUserSettings'))
		}
	]
};

export const SettingsUser = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.user, 
	routes: [
		{
			path: '/settings_user',
			component: React.lazy(() => import('./BasicUserSettings'))
		}
	]
};

export const GeneralSettings = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.user, 
	routes: [
		{
			path: '/general_settings',
			component: React.lazy(() => import('./GeneralSettings'))
		}
	]
};
